import { useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import { UpdateBundle, UpdateBundleVariables } from
  '@/graphql/contracts/_generated_/updateBundle.mutation';
import UpdateBundleMutation from '@/graphql/contracts/updateBundle.mutation.gql';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';
import { ALL_ITEMS, } from '@/config/common.config';
import {
  clearLinesSelection,
} from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/linesSelectionObservable';

export default function useUpdateBundle() {
  const { contractId }: { contractId: UUID } = useParams();

  const [_updateBundle, { loading, data }] = useMutation<UpdateBundle, UpdateBundleVariables>(
    UpdateBundleMutation,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: () => {
        clearLinesSelection();
        notificationService.open({
          title: 'Success',
          text: 'Bundle updated successfully',
          type: 'success'
        });
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetBCContractLinesQuery,
          variables: {
            filter: {
              contractId: { eq: contractId }
            },
            first: ALL_ITEMS
          }
        },
        {
          query: GetPaginatedFilteredVariableContractLinesQuery,
          variables: {
            filter: { headerPrimaryKey: { eq: contractId } },
            first: ALL_ITEMS,
          }
        }
      ]
    }
  );

  const updateBundle = async (input: UpdateBundleVariables['updateBundle']) => {
    const result = await _updateBundle({
      variables: { updateBundle: input }
    });

    return result.data?.updateBundle;
  };

  return {
    updateBundle,
    updatedBundle: data?.updateBundle,
    isLoadingUpdateBundle: loading,
  };
}
